import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "variant-active" }
const _hoisted_2 = { class: "variant-details" }
const _hoisted_3 = { class: "variant-meta" }
const _hoisted_4 = { class: "variant-ids" }
const _hoisted_5 = {
  key: 0,
  class: "variant-title"
}
const _hoisted_6 = {
  key: 2,
  class: "variant-price"
}
const _hoisted_7 = {
  key: 3,
  class: "variant-price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_new = _resolveComponent("toggle-new")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["product-card-variant", {editing: _ctx.editing }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.catalogueVariant)
            ? (_openBlock(), _createBlock(_component_toggle_new, {
                key: 0,
                class: "q-mr-sm",
                dense: "",
                modelValue: _ctx.catalogueVariant.active,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.catalogueVariant.active) = $event)),
                onToggle: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleActive($event)))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_toggle_new, {
                key: 1,
                class: "q-mr-sm",
                dense: "",
                modelValue: _ctx.triggerActivate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.triggerActivate) = $event)),
                onToggle: _ctx.emitAdd
              }, null, 8, ["modelValue", "onToggle"]))
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.variantIds), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["variant-content", { disabled: !_ctx.catalogueVariant?.active }])
          }, [
            (!_ctx.editing || !_ctx.catalogueVariant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args)))
                  }, _toDisplayString(_ctx.catalogueVariant?.title || _ctx.product.title), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["variant-title", { disabled: !_ctx.catalogueVariant?.active}])
                }, [
                  _createVNode(_component_form_input, {
                    "model-value": _ctx.catalogueVariant.title,
                    "onUpdate:modelValue": _ctx.updateTitle,
                    placeholder: !_ctx.catalogueVariant.title ? _ctx.product.title : undefined
                  }, null, 8, ["model-value", "onUpdate:modelValue", "placeholder"])
                ], 2)),
            (!_ctx.editing || !_ctx.catalogueVariant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args)))
                  }, _toDisplayString(_ctx.variantPrice), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_q_input, {
                    class: "price-input",
                    "model-value": _ctx.catalogueVariant.price,
                    "onUpdate:modelValue": _ctx.updatePrice,
                    type: "number",
                    mask: "#.##",
                    "fill-mask": "0",
                    autocomplete: "off",
                    "bg-color": "white",
                    "hide-bottom-space": "",
                    debounce: "100",
                    dense: "",
                    outlined: ""
                  }, {
                    prepend: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("span", null, "€", -1)
                    ])),
                    _: 1
                  }, 8, ["model-value", "onUpdate:modelValue"])
                ]))
          ], 2)
        ])
      ], 2))
    : _createCommentVNode("", true)
}